import { render, staticRenderFns } from "./cardSponsor.vue?vue&type=template&id=0465ec27&scoped=true"
import script from "./cardSponsor.vue?vue&type=script&lang=js"
export * from "./cardSponsor.vue?vue&type=script&lang=js"
import style0 from "./cardSponsor.vue?vue&type=style&index=0&id=0465ec27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0465ec27",
  null
  
)

export default component.exports